import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import * as Yup from 'yup';

import EmailForm from '@components/Form/EmailForm';
import useCorporateLeadCreate from '@hooks/useCorporateLeadCreate';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { RAILS_ENV, RECAPTCHA_SITE_KEY } from '@src/env';
import { ClickTarget, TypingInput } from '@tracking';
import { CORPORATE_EMAIL_ADDRESS } from '@utils/constants';

import { LeadTypes } from './CorporateLeadForm';
import styles from './styles.module.scss';

const schema = Yup.object().shape({
  email: Yup.string().email().required('Email is Required'),
});

const FooterSection = () => {
  const { mutate: createCorporateLead } = useCorporateLeadCreate(true);
  const reCaptchaRef = useRef<ReCAPTCHA>();
  const handleSubmit = async ({ email }: { email: string }) => {
    try {
      const refToken = RAILS_ENV === 'test' ? '' : await reCaptchaRef.current.executeAsync();
      createCorporateLead({
        corporate_lead: { email, lead_type: LeadTypes.Corporate, recaptcha_token: refToken },
      });
    } catch (e) {
      console.error('catching error: ', e);
    }
    reCaptchaRef.current.reset();
  };
  const hydrated = useServerSideRendering();

  return (
    <div className={styles.footerContainer} id="footerContainer">
      <div className="container">
        <div className={styles.footerWrapper}>
          <div className={styles.footerHeader}>Get in Contact</div>
          <div className={styles.footerSubheader}>
            Find out how a Group Subscription can impact your business.
          </div>
          {hydrated && (
            <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} size="invisible" ref={reCaptchaRef}>
              <div className="mx-auto max-w-[380px]">
                <EmailForm
                  buttonText="Contact us"
                  isProcessingSubmission={false}
                  onSubmit={handleSubmit}
                  schema={schema}
                  trackingClickTarget={ClickTarget.CorporateLeadCapture}
                  trackingInputTarget={TypingInput.CorporateLeadCapture}
                />
              </div>
            </ReCAPTCHA>
          )}
          <div className={styles.emailContactWrapper}>
            <div className={styles.emailContact}>
              If you are interested in content distribution or partnerships, please contact{' '}
              <a href={`mailto:${CORPORATE_EMAIL_ADDRESS}`}>{CORPORATE_EMAIL_ADDRESS}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
